import { render, staticRenderFns } from "./DeactivationModal.vue?vue&type=template&id=b7c1865c&scoped=true&"
import script from "./DeactivationModal.vue?vue&type=script&lang=js&"
export * from "./DeactivationModal.vue?vue&type=script&lang=js&"
import style0 from "./DeactivationModal.vue?vue&type=style&index=0&id=b7c1865c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1865c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VTextarea})
